import { BaseResponse, CostResponse } from "../types/responses.type";
import api from "./api";

class CostService {
  static async get(subject: string): Promise<BaseResponse<CostResponse>> {
    try {
      const response = await api.get("/vehicle");
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to fetch vehicles",
      };
    }
  }

  static async update(
    costs: CostResponse[],
  ): Promise<BaseResponse<CostResponse[]>> {
    try {
      const response = await api.put(`/costs`, costs);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      }
      return {
        ok: false,
        errorMessage: "Failed to update costs",
      };
    }
  }
}

export default CostService;
